import { api } from "@/lib/api";

// Fire-and-forget analytics event
export const track = (event, label = "", path = "") => {
  try {
    api.post("/track", { event, label, path: path || (typeof window !== "undefined" ? window.location.pathname : "") }).catch(() => {});
  } catch (_) {}
};

// Normalize text: lowercase + strip accents
const norm = (s = "") =>
  s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\s]/g, " ");

// crude singular/plural + typo tolerance: compare word stems
const stem = (w) => w.replace(/(e|i|o|a|he|hi)$/i, "");

// Search guides by natural query across title/question/keywords/category/answer
export function searchGuides(guides, query, categories = []) {
  const q = norm(query).trim();
  if (!q) return [];
  const terms = q.split(/\s+/).filter((t) => t.length > 1);
  const catName = (slug) => (categories.find((c) => c.slug === slug)?.nome) || slug || "";
  const scored = guides.map((g) => {
    const hayTitle = norm(`${g.titolo} ${g.domanda}`);
    const hayKw = norm((g.keywords || []).join(" "));
    const hayBody = norm(`${g.risposta_breve} ${catName(g.categoria)}`);
    let score = 0;
    for (const t of terms) {
      const st = stem(t);
      if (hayTitle.includes(t)) score += 5;
      else if (hayTitle.includes(st)) score += 3;
      if (hayKw.includes(t)) score += 4;
      else if (hayKw.includes(st)) score += 2;
      if (hayBody.includes(t)) score += 1;
    }
    return { g, score };
  });
  return scored.filter((s) => s.score > 0).sort((a, b) => b.score - a.score).map((s) => s.g);
}
